// extracted by mini-css-extract-plugin
export var avatarContainer = "_4w-1";
export var largeAvatarContainer = "_4w-2";
export var smallAvatarContainer = "_4w-0";